import { GraphQLRepository } from '../utils/graphQL-repository'
import {
  DO_LOGIN,
  FULFILL_CLOSE_TRADE,
  FULFILL_USER_ACCOUNT,
  GET_ALLOWED_LEVERAGES,
  GET_CLOSED_POSITIONS,
  GET_TRANSLATIONS,
  GET_USER_ACCOUNT,
  INIT_GRAPH_QL_REPO,
  SELECT_ACCOUNT,
  GET_FAVOURITES,
  UPDATE_FAVOURITES,
} from '../constants'
import { Epic, ActionsObservable } from 'redux-observable'
import {
  // AccountDetails,
  RootState,
  ViewerWrapper,
} from '../types'
import { MiddlewareAPI, Action } from 'redux'
import {
  closedPositionsQuery,
  closedPositionsQueryVariables,
  getAllowedLeveragesQuery,
  MT4ServerType,
  getFavouritesQuery,
} from '../graphql/schema'
import {
  fulfillGetAllowedLeverages,
  fulfillGetClosedPositions,
  fulfillUserAccount,
  GetAllowedLeveragesAction,
  getClosedPositions,
  GetClosedPositionsAction,
  GetTranslations,
  GetUserAccountAction,
  InitGraphQLRepo,
} from '../actions/GraphQLActions'
import * as graphQlActions from '../actions/GraphQLActions'
import { Observable } from 'rxjs/Observable'
import { SelectAccount, setAccount } from '../actions'
import { loadTranslations, TranslationObjects } from 'react-redux-i18n'
import { clearState, setLocale } from '../actions/commonActions'
import { getServerTypeByAccountType } from '../utils/common-utils'
import { ServerType, MT4Connector } from '@bdswiss/mt4-connector'

import { translations as localTranslations } from '../utils/translations'

const mt4 = MT4Connector.Instance
const repository: GraphQLRepository = GraphQLRepository.Instance
// let currentLogin: string;

// if (repository) {
//   console.log('Repository loaded')
// }

export const initGraphQlRepoEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  action$.ofType(INIT_GRAPH_QL_REPO).map(({ token }: InitGraphQLRepo) => {
    if (token) {
      repository.Token = token
    }
    return graphQlActions.getUserAccount(token)
  })

export const refreshInfoOnAccountSwitch: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  (action$ as ActionsObservable<SelectAccount>).ofType(SELECT_ACCOUNT).switchMap(() => {
    mt4.disconnect()
    const nextActions: Action[] = [clearState(), graphQlActions.getUserAccount()]
    // if (type === 'bond') {
    //     nextActions.push(getBondConfig())
    // }
    return Observable.from<Action>(nextActions)
  })

export const getAccountsOnLoginEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  action$.ofType(DO_LOGIN).map((action) => {
    return graphQlActions.getUserTradingAccounts()
  })

export const getClosedPositionsOnCloseTradeEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) => action$.ofType(FULFILL_CLOSE_TRADE).map((action) => getClosedPositions())

export const getClosedPositionsEpic: Epic<GetClosedPositionsAction, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  action$.ofType(GET_CLOSED_POSITIONS).switchMap((action) => {
    const { limit } = action
    const { activeAccount: currentLogin } = state.getState().appState
    const accountTypename = state
      .getState()
      .tradingAccounts.viewer.accounts.find((acc) => acc.login === currentLogin)!.__typename
    const server = getServerTypeByAccountType(accountTypename)
    const env: closedPositionsQueryVariables = {
      limit,
      login: Number(currentLogin),
      offset: 0,
      server: server as MT4ServerType,
    }

    return repository
      .getClosedPositions(env)
      .map((data: closedPositionsQuery) => fulfillGetClosedPositions(data))
  })

export const getUserTradingAccountsEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  action$.ofType(GET_USER_ACCOUNT).switchMap((action: GetUserAccountAction) => {
    if (action.authToken) {
      repository.Token = action.authToken
    }
    if (action.url) {
      repository.Url = action.url
    }
    const { preferredAccountType, accountLogin } = state.getState().appConfig
    // setAccount(login);

    return repository.getViewer().switchMap((data: ViewerWrapper) => {
      const accounts = data.viewer.accounts
        .filter(
          (acc) =>
            acc.login &&
            (acc.__typename.includes('Forex') ||
              acc.__typename.includes('Cent') ||
              acc.__typename.includes('Bond')) &&
            !acc.isArchived &&
            !acc.hidden
        )
        .map((acc) => {
          return {
            ...acc,
            serverType: getServerTypeByAccountType(acc.__typename) as ServerType,
          }
        })

      return accountLogin && accounts.map((account) => account.login).includes(accountLogin)
        ? Observable.of(fulfillUserAccount({ ...data, viewer: { ...data.viewer, accounts } }))
        : Observable.of<Action>(
            setAccount(data, preferredAccountType),
            setLocale(data.viewer.locale || 'en'),
            fulfillUserAccount({ ...data, viewer: { ...data.viewer, accounts } })
          )
    })
  })

export const getWebApiDataEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  action$.ofType(FULFILL_USER_ACCOUNT).switchMap((action) => {
    return Observable.from([
      graphQlActions.getTranslations(),
      graphQlActions.getClosedPositions(),
      graphQlActions.getFavourites(),
      // ...demo?[]:[graphQlActions.getAllowedLeverages(currentAccount.id!)]
    ])
  })

export const getAllowedLeveragesEpic: Epic<GetAllowedLeveragesAction, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  action$.ofType(GET_ALLOWED_LEVERAGES).switchMap(({ accountId }) => {
    return repository
      .getAllowedLeverages({ accountId })
      .map((data: getAllowedLeveragesQuery) => fulfillGetAllowedLeverages(data))
  })

export const getTranslationsEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  action$.ofType(GET_TRANSLATIONS).switchMap((action: GetTranslations) => {
    const locale = state.getState().appConfig.locale
    const lang = locale ? locale : state.getState().tradingAccounts.viewer.locale

    return repository.getTranslations(locale!).map((serverTranslations: TranslationObjects) => {
      Object.keys(localTranslations.en).forEach((val) => {
        if (serverTranslations[val] === undefined) {
          serverTranslations[val] = (localTranslations.en as any)[val]
        }
      })
      return loadTranslations({ [lang]: serverTranslations })
    })
  })

export const getFavouritesEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  action$.ofType(GET_FAVOURITES).switchMap((action: graphQlActions.GetFavouritesAction) => {
    const { demo } = state.getState().appConfig
    if (demo) {
      return Observable.empty()
    } else {
      return repository.getFavourites().switchMap(({ viewer }: getFavouritesQuery) => {
        if (viewer && viewer.hasOwnProperty('tradingConfig')) {
          return Observable.of(
            graphQlActions.fulfillGetFavourites((viewer as any).tradingConfig.favourites)
          )
        } else {
          return Observable.empty()
        }
      })
    }
  })

export const updateFavouritesEpic: Epic<graphQlActions.UpdateFavouritesAction, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  action$.ofType(UPDATE_FAVOURITES).mergeMap(({ favourites }) => {
    const { demo } = state.getState().appConfig
    if (demo) {
      return Observable.of(graphQlActions.fulfillUpdateFavourites(favourites))
    } else {
      return repository.updateFavourites({ favourites }).map((data: any) => {
        return graphQlActions.fulfillUpdateFavourites(data.data.updateFavourites.favourites)
      })
    }
  })
